export const AMOUNT_REPRESENTATION_VALUES = {
  GENERALIZED: 'generalized',
  HIGHLIGHTED: 'highlighted_credit_transactions',
};
